<div class="card">
  <div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
    <div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
      <div class="dropdown me-3">
        <select id="financialYear" [formControl]="selectedFinancialYear" class="form-select">
          <option value="" selected disabled>Select Financial Year</option>
          <option *ngFor="let year of financialYears" [value]="year">{{ year }}</option>
        </select>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-8">
    <div class="card">
      <div class="card-header">
        <h4>TDS Calculation</h4>
      </div>
      <div class="card-body">
        <table class="table">
          <colgroup>
            <col style="width: 70%" />
            <col style="width: 30%" />
          </colgroup>
          <thead class="thead-light">
            <tr>
              <th>Type</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Regime</td>
              <td>New Regime</td>
            </tr>
          </tbody>
        </table>
        <!--<ng-template #noRecords>
          <div class="text-center">Record not available</div>
        </ng-template>-->
      </div>
    </div>
  </div>
  <div class="col-4">
    <div class="card">
      <div class="card-header justify-content-between">
        <div class="card-title">FAQ</div>
      </div>
      <div class="card-body">
        <div class="accordions-items-seperate" id="accordionSpacingExample">
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingSpacingOne">
              <button
                class="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#SpacingOne"
                aria-expanded="false"
                aria-controls="SpacingOne"
              >
                Why is my Net Salary different from my CTC?
              </button>
            </h2>
            <div
              id="SpacingOne"
              class="accordion-collapse collapse"
              aria-labelledby="headingSpacingOne"
              data-bs-parent="#accordionSpacingExample"
            >
              <div class="accordion-body">
                CTC is annual amount and may include non-recurring components such as Bonus and LTA.
                Non-recurrcing components are not paid monthly. Additionally there may be deductions
                such as PT, TDS, etc which may further reduce your take home pay.
              </div>
            </div>
          </div>
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingSpacingTwo">
              <button
                class="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#SpacingTwo"
                aria-expanded="false"
                aria-controls="SpacingTwo"
              >
                Why is the monthly TDS amount different from my manual calculations?
              </button>
            </h2>
            <div
              id="SpacingTwo"
              class="accordion-collapse collapse"
              aria-labelledby="headingSpacingTwo"
              data-bs-parent="#accordionSpacingExample"
            >
              <div class="accordion-body">
                There may be various reasons for this: to view AVR HRMS calculations you may click
                on the link for detailed calculations on selecting a specific month. Common
                discrepancies may include manual error in date of joining entry, salary changes
                during a year - so projected FY salary may vary. Please make sure the tax regime
                selection in AVR HRMS is same as what manual calculations assume. Additionally
                sometimes the investment declarations may not be present in AVR HRMS.
              </div>
            </div>
          </div>
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingSpacingThree">
              <button
                class="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#SpacingThree"
                aria-expanded="false"
                aria-controls="SpacingThree"
              >
                Who do I contact for further queries?
              </button>
            </h2>
            <div
              id="SpacingThree"
              class="accordion-collapse collapse"
              aria-labelledby="headingSpacingThree"
              data-bs-parent="#accordionSpacingExample"
            >
              <div class="accordion-body">
                You may either raise a ticket at AVR HRMS suport website or contact your company's
                admin / HR
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
